import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge, taught the portal's custom `text-*` tokens.
 *
 * Out of the box, tailwind-merge sees `text-portal-micro` (a font size) and
 * `text-portal-success` (a color) as the same `text-*` utility and, assuming
 * they conflict, drops one — silently stripping the font size from every
 * `text-<size> text-<color>` pair in the design system. Registering the
 * custom size tokens and color tokens into the correct groups keeps both.
 */
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        {
          text: [
            'portal-micro',
            'portal-tiny',
            'portal-small',
            'portal-body',
            'portal-credit',
            'portal-card-title',
            'portal-section',
            'portal-stat',
            'portal-page',
          ],
        },
      ],
      'text-color': [
        {
          text: [
            'portal-ink',
            'portal-muted',
            'portal-success',
            'brand',
            'brand-link',
            'brand-accent',
          ],
        },
      ],
    },
  },
});

/**
 * Joins class fragments and resolves Tailwind conflicts, last-wins.
 *
 * Components set default utilities and accept a `className` to override them
 * (e.g. `w-[110px]` over a component's `w-full`). A plain join would emit both
 * and let stylesheet order decide — fragile. tailwind-merge keeps the caller's
 * override deterministically; the extension above stops it from confusing a
 * font-size token for a color token.
 *
 * @param parts - Class fragments; false/undefined/null are skipped.
 * @returns The merged class string.
 */
export function cn(...parts: readonly (string | false | null | undefined)[]): string {
  return twMerge(parts.filter(Boolean).join(' '));
}
